<template>
  <a-flex align="center" justify="space-between" v-bind="$attrs">
    <a-typography-text :content="header" ellipsis />
    <a-badge :count="newMessagesCount" v-if="newMessagesCount > 0" />
  </a-flex>
</template>

<script setup lang="ts">
const { header, newMessagesCount = 0 } = defineProps<{
  header: string;
  newMessagesCount?: number;
}>();
</script>

<style scoped lang="scss"></style>
